import { FETCH_SERVICE_PORT_CONTACTS_SUCCESS } from "../action/services.action";
import { FETCH_VESSEL_DETAIL_BY_ID_SUCCESS } from "../action/vessels.action";

const initialState = {
  detail: {},
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_VESSEL_DETAIL_BY_ID_SUCCESS:
      return {
        ...state,
        detail: action.payload
      }
    default:
      return state;
  }
}